import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo.webp";
import {
  FaFacebook,
  FaInstagram,
  FaPhone,
  FaSnapchat,
  FaTiktok,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export default function CSFooter() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-12 content">
            <div className="footer-nav">
              <ul>
                <li>
                  <Link to={"/contact"} aria-label="تواصل معنا">
                    تواصل معنا
                  </Link>
                </li>
                <li>
                  <Link to={"/policy"} aria-label="السياسة والخصوصية">
                    السياسة والخصوصية
                  </Link>
                </li>
              </ul>
            </div>
            <div className="logo">
              <Link to={"/"}>
                <img
                width={'200px'}
                  src={LOGO}
                  alt="شعار الحلول الميسرة"
                  loading="lazy" // خاصية التحميل الكسول
                  className="footer-logo" // إضافة فئة لتنسيق الشعار
                />
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-sm-12 footer-contact">
            <div className="footer-contact-nav">
              <ul className="contact-btn">
                <li className="ml-link">
                  <a
                    href="tel:+966565381443"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="اتصل بنا على الهاتف"
                  >
                    <FaPhone />
                  </a>
                </li>
                <li className="ws-link">
                  <a
                    href="https://wa.me/+966565381443"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="تواصل عبر واتساب"
                  >
                    <FaWhatsapp />
                  </a>
                </li>
                <li className="ml-link">
                  <a
                    href="tel:+966112229479"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="اتصل بنا على الهاتف"
                  >
                    <FaPhone />
                  </a>
                </li>
                <li className="ws-link">
                  <a
                    href="https://wa.me/+966112229479"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="تواصل عبر واتساب"
                  >
                    <FaWhatsapp />
                  </a>
                </li>
                <li className="ml-link">
                  <a
                    href="mailto:easy.solutions2030@gmail.com"
                    aria-label="إرسال بريد إلكتروني"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <MdEmail />
                  </a>
                </li>
              </ul>
              <ul className="social-media">
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=100074072641761&mibextid=ZbWKwL"
                    aria-label="صفحتنا على فيسبوك"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebook />
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/E_solutions2030"
                    aria-label="صفحتنا على تويتر"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/easy_solutions1/profilecard/?igsh=M2JzN3pjZzlzNWNu"
                    aria-label="صفحتنا على إنستجرام"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.snapchat.com/add/easy.solutions1?share_id=9_VD2qK3Zts&locale=ar-SA"
                    aria-label="صفحتنا على سناب شات"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaSnapchat />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@e_solutions2030?_t=8qxSKRugL7n&_r=1"
                    aria-label="صفحتنا على تيك توك"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaTiktok />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12">
            <p>الحقوق محفوظة © الحلول الميسرة 2024 </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
